import { Box, BoxProps, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { FAIcon } from '@packages/ui-components';
import { fontAwesomeToLucideMap } from '../../../components/icons/lucide-mapping';

type Props = BoxProps & {
  icon: string;
  style?: string;
  size?: 'large' | 'medium' | 'small';
};

export default function Icon({ icon, style = 'far', size = 'medium', onClick, sx }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Logic for responsive icon font size. Will be finished later
  const fontSize = useMemo(() => {
    if (size === 'large') {
      return isMobile ? '20px' : '30px';
    }
    if (size === 'medium') {
      return isMobile ? '20px' : '20px';
    }
    return '15px';
  }, [size, isMobile]);

  // Convert string sizes to numbers for Lucide
  const numericSize = parseInt(fontSize.replace('px', ''), 10);

  // Try to find a Lucide equivalent first
  const lucideIcon = fontAwesomeToLucideMap[icon];

  if (lucideIcon) {
    // Use Lucide icon via FAIcon component
    return (
      <FAIcon
        icon={lucideIcon}
        size={numericSize}
        color={theme.palette.common.white}
        onClick={onClick}
        sx={sx}
      />
    );
  }

  // Fallback to FontAwesome for icons not yet mapped
  return (
    <Box
      onClick={onClick}
      component="i"
      className={`${style} ${icon} fa-fw`}
      sx={{ ...sx, fontSize: `${fontSize} !important`, color: theme.palette.common.white }}
    />
  );
}
